module.exports = __webpack_public_path__ + "img/20190919155751886.12ad74d8.jpg";